module.exports = __webpack_public_path__ + "static/media/MessagesText.432d5073.svg";